import PropTypes from "prop-types"
import React, { useState } from "react"
import {Col, FormGroup, Input, Label} from "reactstrap"
import Tooltip from "./tooltip"
import { withTranslation } from "react-i18next"

const FormInputColor = props => {
  const { attribute, description, value, setValue, disabled, changeHandeler, required, title, keyTranslate, additionalText, labelColumns } = props

  const [touched, setTouched] = useState(false)

  const changeHandelerInput = (valor, elementId, validacao) => {
    if(validacao !== null && validacao !== undefined) {
      if(validacao === false) {
        document.getElementById(elementId).style.display = 'block'
      } else {
        document.getElementById(elementId).style.display = 'none'
      }
    } else {
      if (valor !== "" && valor !== undefined && valor !== null) {
        document.getElementById(elementId).style.display = 'none'
      } else {
        document.getElementById(elementId).style.display = 'block'
      }
    }
  }

  return (
      <React.Fragment>
        <FormGroup className="mb-4" row>
          <Label htmlFor={ attribute + "-color" } className={ "col-form-label " + (labelColumns ? 'col-lg-' + labelColumns : 'col-lg-2')}>
            { keyTranslate ? props.t(keyTranslate + '.label') : description }
            { keyTranslate && <Tooltip id={ attribute + "-title"} tooltip={ props.t(keyTranslate + '.title') }></Tooltip>}
          </Label>
          <Col className="col-1 col-md-1 col-sm-2">
            <Input
                id={ attribute + "-color"}
                name={ attribute + "-color"}
                type="color"
                className={ "form-control " + (touched && required && !value? "is-invalid" : "") }
                value={ value }
                onChange={ e => {
                  if(!touched) setTouched(true)
                  setValue(e.target.value)

                  if(required) {
                    if(changeHandeler !== undefined) {
                      changeHandeler(e.target.value, `validate-required-${ attribute }-color`)
                    } else {
                      changeHandelerInput(e.target.value, `validate-required-${ attribute }-color`)
                    }
                  }
                } }
                title={ keyTranslate ? props.t(keyTranslate + '.title') : title}
                required={ required }
                disabled={ disabled }
            />
            { required &&
                <div className={ value ? "" : "invalid-tooltip" }
                     name="validate-required" id={ `validate-required-${ attribute }-color` }>
                  { value ? "" : `${ description } é obrigatório(a)`}
                </div>
            }
            { additionalText &&
              <span name="additional-text" id={ `additional-text-${ attribute }` }>
              { additionalText }
            </span>
            }
          </Col>
        </FormGroup>
      </React.Fragment>
  )
}

FormInputColor.propTypes = {
  attribute: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.any,
  setValue: PropTypes.func,
  disabled: PropTypes.bool,
  labelColumns: PropTypes.number,
  changeHandeler: PropTypes.func,
}

export default withTranslation()(FormInputColor)
